module.exports = __webpack_public_path__ + "img/5.bd1b009.jpg";